/**
 * G then a letter jumps to a header, Settings Learn, or avatar-menu page.
 * Not used on Unified or a deal, where G already cycles the view.
 */

export const GO_WAIT_MS = 800;

const PUBLIC_PREFIXES = [
  "/login",
  "/privacy",
  "/terms",
  "/faq",
  "/tools",
  "/learn",
  "/unsubscribe",
  "/tc-invite",
  "/invite",
];

export const GO_DESTINATIONS = [
  { key: "d", id: "dashboard", label: "Dashboard", path: "/dashboard" },
  { key: "g", id: "dashboard-gg", label: "Dashboard", path: "/dashboard", hiddenInHelp: true },
  { key: "t", id: "team", label: "Team", path: "/broker", needs: "team" },
  { key: "c", id: "tc-dashboard", label: "TC Dashboard", path: "/tc-dashboard", needs: "tcDashboard" },
  { key: "p", id: "tc-performance", label: "TC Performance", path: "/tc-performance", needs: "tcPerformance" },
  { key: "h", id: "tools", label: "Hawaii Calculators", path: "/tools", newTab: true },
  { key: "l", id: "learn", label: "Learn", path: "/learn" },
  { key: "s", id: "settings", label: "Settings", path: "/settings" },
  { key: "m", id: "templates", label: "Templates", path: "/templates" },
  { key: "u", id: "unified", label: "Unified", path: "/unified", needs: "unified" },
  { key: "a", id: "admin", label: "Super Admin", path: "/admin", needs: "superAdmin" },
];

export function goPrefixEnabled(pathname) {
  if (!pathname || pathname === "/") return false;
  if (PUBLIC_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return false;
  }
  if (pathname === "/unified") return false;
  if (pathname.startsWith("/transaction/")) return false;
  return true;
}

export function isBareLetterG(e) {
  if (!e || e.repeat || e.isComposing) return false;
  if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return false;
  return e.key === "g" || e.key === "G";
}

export function secondGoLetter(e) {
  if (!e || e.isComposing) return null;
  if (e.metaKey || e.ctrlKey || e.altKey) return null;
  if (e.key === "Escape") return "escape";
  if (typeof e.key === "string" && e.key.length === 1) return e.key.toLowerCase();
  return null;
}

export function destinationAllowed(dest, access = {}) {
  if (!dest) return false;
  if (dest.needs === "team") return Boolean(access.showTeamHome);
  if (dest.needs === "tcDashboard") return Boolean(access.showTcDashboard);
  if (dest.needs === "tcPerformance") return Boolean(access.showTcPerformance);
  if (dest.needs === "superAdmin") return Boolean(access.showSuperAdmin);
  if (dest.needs === "unified") return Boolean(access.showUnified);
  return true;
}

export function resolveGoDestination(letter, access = {}) {
  const dest = GO_DESTINATIONS.find((row) => row.key === letter);
  if (!dest) return { ok: false, reason: "unknown" };
  if (!destinationAllowed(dest, access)) return { ok: false, reason: "gated", dest };
  return { ok: true, dest };
}

/** Cheat sheet list: product pages, not Super Admin. */
export function goHelpItemsForSheet() {
  return GO_DESTINATIONS.filter(
    (row) => !row.hiddenInHelp && row.needs !== "superAdmin"
  ).map((row) => ({
    keys: `G ${row.key.toUpperCase()}`,
    label: `Go to ${row.label}`,
  }));
}
